import SEOHead from '@/components/base/SEOHead';
import JsonLd from '@/components/base/JsonLd';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategorySection from './components/CategorySection';
import ArticleList from './components/ArticleList';
import FAQSection from './components/FAQSection';

export default function Home() {
  const websiteSchema = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '猫咪视频大全',
    url: 'https://catvideo.cn',
    description: '汇聚全网最热门、最治愈的猫咪视频，涵盖搞笑猫咪视频、可爱猫咪日常、萌猫短片等精选内容。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://catvideo.cn/search?q={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '猫咪视频大全',
    url: 'https://catvideo.cn',
    description: '国内领先的猫咪视频内容聚合平台',
    email: 'hello@catvideo.cn',
    address: {
      '@type': 'PostalAddress',
      addressLocality: '杭州',
      addressRegion: '浙江',
      addressCountry: 'CN',
    },
  };

  return (
    <>
      <SEOHead
        title="猫咪视频大全｜最萌最治愈的猫咪视频合集"
        description="汇聚全网最热门、最治愈的猫咪视频，涵盖搞笑猫咪视频、可爱猫咪日常、萌猫短片等精选内容。无论你是资深猫奴还是新手铲屎官，这里的猫咪视频都能让你瞬间解压、治愈心灵，每日更新最新猫咪视频合集。"
        keywords="猫咪视频,搞笑猫咪视频,可爱猫咪视频合集,治愈猫咪短视频,萌猫日常视频,猫咪视频大全,猫咪搞笑短片,铲屎官必看视频"
        canonicalUrl="https://catvideo.cn"
        ogImage="https://readdy.ai/api/search-image?query=Warm%20cozy%20scene%20with%20cute%20cats%20of%20different%20breeds%20sitting%20on%20a%20cream%20sofa%20soft%20warm%20lighting%20healing%20peaceful%20atmosphere%20clean%20minimalist%20composition%20with%20warm%20peach%20tones&width=1200&height=630&seq=og-home&orientation=landscape"
        ogImageWidth={1200}
        ogImageHeight={630}
      />
      <JsonLd data={websiteSchema} />
      <JsonLd data={organizationSchema} />

      <div className="min-h-screen">
        <Navbar />
        <main>
          <Hero />
          <CategorySection />
          <ArticleList />
          <FAQSection />
        </main>
        <Footer />
      </div>
    </>
  );
}